export type FormSheetTab = {
  value: string;
  label?: string;
  hide?: boolean;
  subtab?: readonly FormSheetTab[];
  action?: () => void;
};

export const MANAGE_PHOTOS_TAB_VALUE = "manage-photos";

const LOCALISATION_TAB_VALUES = ["localisation-historique"] as const;
const HISTORIQUE_TAB_VALUES = ["historique"] as const;
const DIMENSIONS_TAB_VALUES = ["dimensions-poids", "dimensions"] as const;

/**
 * Insère l'entrée « Gérer les photos » entre Dimensions et poids
 * et Localisation / Historique lorsque ces onglets existent.
 */
export function injectManagePhotosTab<T extends FormSheetTab>(
  tabs: readonly T[],
  photoTab: FormSheetTab & { action: () => void },
): (T | (FormSheetTab & { action: () => void }))[] {
  if (tabs.some((tab) => tab.value === MANAGE_PHOTOS_TAB_VALUE)) {
    return [...tabs];
  }

  const localisationIndex = tabs.findIndex((tab) =>
    LOCALISATION_TAB_VALUES.includes(
      tab.value as (typeof LOCALISATION_TAB_VALUES)[number],
    ),
  );
  const historiqueIndex = tabs.findIndex((tab) =>
    HISTORIQUE_TAB_VALUES.includes(
      tab.value as (typeof HISTORIQUE_TAB_VALUES)[number],
    ),
  );
  const dimensionsIndex = tabs.findIndex((tab) =>
    DIMENSIONS_TAB_VALUES.includes(
      tab.value as (typeof DIMENSIONS_TAB_VALUES)[number],
    ),
  );

  let insertAt = tabs.length;

  if (localisationIndex >= 0) {
    insertAt = localisationIndex;
  } else if (historiqueIndex >= 0) {
    insertAt = historiqueIndex;
  } else if (dimensionsIndex >= 0) {
    insertAt = dimensionsIndex + 1;
  } else {
    const descriptionIndex = tabs.findIndex((tab) => tab.value === "description");
    if (descriptionIndex >= 0) {
      insertAt = descriptionIndex + 1;
    }
  }

  const next = [...tabs] as (T | (FormSheetTab & { action: () => void }))[];
  next.splice(insertAt, 0, photoTab);
  return next;
}

export function createManagePhotosTab(
  onClick: () => void,
  labelKey = "formulaireBannierePhotosBouton",
): FormSheetTab & { action: () => void } {
  return {
    value: MANAGE_PHOTOS_TAB_VALUE,
    label: labelKey,
    action: onClick,
  };
}
